<template>
  <FaIcon :icon="['fas', 'circle-info']" />
</template>
